import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
export class ElementNode {
  bind = {}
  key = ""
  on = {}  
  type = ''
  cmpPath = ''
  pid = null
  value = null;
  // 直接引用组件初始化
  static _VMNative (ctx){
    let { quoteKey } = ctx    
    ElementNode.bindVM(ctx,quoteKey)
  }
  // 配置方式引入，标准模式
  static bindVM (ctx,key){
    ctx.$watch(
      key,
      (nv) => {
        // console.log('element-node-mixin -change',nv)
        ctx.$emit('input', nv)
      },
      {
        deep: true
      }
    )
  }
  constructor (args){
    this.init(args)
  }
  init (args){
    for(let i in args){
      this[i] = args[i]
    }
  }
  VMNative (ctx) {
    let { key,value } = this
    let { quoteKey } = ctx
    ctx[key] = value    
    if(quoteKey){
      // 配置方式引入，但存在绑定额外key
      ctx[quoteKey] = value || ctx[quoteKey]
      ElementNode.bindVM(ctx,quoteKey)
    }else{
      ElementNode.bindVM(ctx,key)
    }
  }  
    
  get (){
    
  }
  // 更新父级
  updateCompNodeData (){
    const { key,value } = this
    console.log('ElementNode:this.pid',this.pid)
    console.log('ElementNode:data',{[key]:value})
    TmpStore.$emit(this.pid,{[key]:value})
  }
  set (value){
    // console.log(this.key,'ElementNode:set',value)
    this.value = value
    // TmpStore.$emit(this.pid,)
    this.updateCompNodeData()
  }
}